import React from 'react';
import { PlanChangeValues, formatCents, formatShortDate } from './PlanChangeParts';
import styles from './PlanChangeModal.module.css';

/**
 * Quadro de valores da troca para um plano menor (DowngradePlanModal e
 * PlanFitModal de quem já assina): crédito do que sobra do plano atual e a
 * próxima cobrança já com o crédito descontado. Recebe o resultado de
 * usePlanChangeSimulation. Sem prévia, fica o texto genérico.
 */
const PlanChangeCreditValues = ({ simulation, loading }) => {
  const hasPreview = simulation && typeof simulation.next_charge_cents === 'number';

  if (!loading && !hasPreview) {
    return (
      <p className={styles.valuesFallback}>
        A cobrança é ajustada automaticamente pelo Stripe: o que sobra do plano atual é descontado nas próximas cobranças.
      </p>
    );
  }

  const creditCents = simulation?.credit_cents || 0;
  const nextDate = formatShortDate(simulation?.next_due_date);
  const rows = [];
  if (loading || creditCents > 0) {
    rows.push({
      label: 'Crédito do plano atual',
      value: formatCents(creditCents),
      hint: 'O que sobra do ciclo, descontado na próxima cobrança',
      tone: 'success',
    });
  }
  rows.push({
    label: 'Próxima cobrança',
    value: formatCents(simulation?.next_charge_cents),
    hint: [nextDate ? `Em ${nextDate}` : null, creditCents > 0 ? 'já com o crédito descontado' : null]
      .filter(Boolean).join(', ') || null,
  });

  return <PlanChangeValues rows={rows} loading={loading} />;
};

export default PlanChangeCreditValues;
